import React, { useState } from 'react';
import { useRef, useEffect, forwardRef, useImperativeHandle } from 'react'
import { ReactSVG } from "react-svg";
import i18n from "../../i18n/i18n.js";
import PageHeader from '../PageHeader/PageHeader.js';
import TypedLink from '../../components/TypedLink/TypedLink';


import './ProductsFilters.css';
const ProuctsFilters = forwardRef((props, ref) => {

    const [filterLoading,setFilterLoading] = useState({'loading':((props.filter_loading) ? props.filter_loading : 0)});
    const [blocksOpened,setBlocksOpened] = useState({'color':0,'size':0,'gender':0});
    const [listSettings,setListSettings] = useState({});
    const setProductsOrderBy = (props.setProductsOrderBy) ? props.setProductsOrderBy : ()=>{};
    const isVisible = (props.isVisible) ? props.isVisible :  false;
    const [aimation,setAnimation] = useState({'animate':(props.filterAnimation!==undefined) ?  props.filterAnimation : true});
    const loadProductList = (props.loadProductList && typeof props.loadProductList=='function') ? props.loadProductList : ()=>{};
    const [filterInit,setFilterInit] = useState({'init':false});

    useEffect(()=>{

        if(!filterInit.init){

            setFilterInit({'init':true});
            setFilterLoading({'loading':1});

            loadProductList({'get_filters':true},(resp)=>{
                setAnimation({animate:false});
                setFilterLoading({'loading':0});
                if(resp.list_settings){
                    setListSettings(resp.list_settings);
                }
            });
            
        }

    })

    useEffect(() => {
        const handleHideFilters = () => {
            if(typeof props.hideFromParent === 'function') {
                props.hideFromParent(0, true);
            }
        };
        
        window.addEventListener('hideProductFilters', handleHideFilters);
        return () => window.removeEventListener('hideProductFilters', handleHideFilters);
    }, [props.hideFromParent]);

    const hide = (e) => {
        if(typeof props.hideFromParent==='function'){
            props.hideFromParent(0,true);
        }
    };

    const toggle_filter_block = (set_to) => {
        const new_blocks = {...blocksOpened,...set_to}
        setBlocksOpened(new_blocks);
    }
      
    return <div key={listSettings.settings_hash} className={'container floating_container products_list_filters '+(!aimation.animate ? 'no-animation' : '')} style={(!isVisible) ? {display:'none'} : {}}>

        <PageHeader parent_ref={this} callback={hide} no_back="true" title={i18n.t('productsFilterTitle')}></PageHeader>
        {filterLoading.loading===1 ? <div className='loader_cont'><div className='loader'><ReactSVG src='assets/images/dorko_loader.svg'></ReactSVG></div></div> : ''}
        <div className='filter_blocks_cont'>

            {listSettings?.products_order_by?.selected ? 
                <div className='filter_block'>
                    <div className='filter_block_title'>{i18n.t('productsFilterOrderByLabal')}</div>
                    <div className='filter_items_cont'>
                        <div className="select">
                            <select name="set_order_by" onChange={(e)=>{setFilterLoading({'loading':1});  setProductsOrderBy(e.target.value)}} defaultValue={listSettings.products_order_by.selected} >
                                {listSettings?.products_order_by?.items ? Object.keys(listSettings.products_order_by.items).map((key,index)=><option key={key} value={key}>{listSettings.products_order_by.items[key]}</option>) : ''}
                            </select>
                            <ReactSVG src="assets/images/arrow_down.svg" />
                        </div>
                    </div>
                </div>
            : ''}

            {listSettings?.filters?.pp_filters?.product_color?.items && Object.keys(listSettings.filters.pp_filters.product_color.items).length>0 ? 
            <div className={'filter_block toggle'+(blocksOpened.color ? ' open' : '')}>
                <div className='filter_block_title' onClick={()=>{toggle_filter_block({'color':Math.abs(blocksOpened.color-1)})}}>{i18n.t('productsFilterColorLabal')} <span><ReactSVG src="assets/images/arrow_down.svg" /></span></div>
                <div className='filter_items_cont'>
                    {Object.keys(listSettings.filters.pp_filters.product_color.items).map((val,index)=>{
                        const filter_item = listSettings.filters.pp_filters.product_color.items[val];
                        return <div className='color_item'>
                            <TypedLink onClick={hide} link={{ type: 'products', url: filter_item.url, title: ''}}>
                                <label><input type='checkbox' name='filter_color[]' defaultChecked={filter_item.selected} value={filter_item.url}/> <span>{filter_item.label}</span></label>
                            </TypedLink>
                        </div>;
                    })}
                </div>
            </div>
            : ''}
            
            {listSettings?.filters?.pp_filters?.product_size_eu?.items && Object.keys(listSettings.filters.pp_filters.product_size_eu.items).length>0 ? 
            <div className={'filter_block toggle'+(blocksOpened.size ? ' open' : '')}>
                <div className='filter_block_title'  onClick={()=>{toggle_filter_block({'size':Math.abs(blocksOpened.size-1)})}}>{i18n.t('productsFilterSizeByLabal')} <span><ReactSVG src="assets/images/arrow_down.svg" /></span></div>
                <div className='filter_items_cont'>
                    {Object.keys(listSettings.filters.pp_filters.product_size_eu.items).map((val,index)=>{
                        const filter_item = listSettings.filters.pp_filters.product_size_eu.items[val];
                        return <div className= {(filter_item.block_label) ? 'filter_items_label' : 'size_item'}>
                            {(filter_item.block_label) ?
                               filter_item.label
                            : <TypedLink onClick={hide} link={{ type: 'products', url: filter_item.url, title: ''}}>
                                <label><input type='checkbox' name='filter_size[]' defaultChecked={filter_item.selected} value={filter_item.url}/> <span>{filter_item.label}</span></label>
                            </TypedLink>}
                            
                        </div>;
                    })}
                </div>
            </div>
            : ''}

            {listSettings?.filters?.pp_filters?.product_gender?.items && Object.keys(listSettings.filters.pp_filters.product_gender.items).length>0 ? 
            <div className={'filter_block toggle'+(blocksOpened.gender ? ' open' : '')}>
                <div className='filter_block_title'  onClick={()=>{toggle_filter_block({'gender':Math.abs(blocksOpened.gender-1)})}}>{i18n.t('productsFilterGenderLabal')}<span><ReactSVG src="assets/images/arrow_down.svg" /></span></div>
                <div className='filter_items_cont'>
                    {Object.keys(listSettings.filters.pp_filters.product_gender.items).map((val,index)=>{
                        const filter_item = listSettings.filters.pp_filters.product_gender.items[val];
                        return <div className='color_item'>
                            <TypedLink onClick={hide} link={{ type: 'products', url: filter_item.url, title: ''}}>
                                <label><input type='checkbox' name='filter_color[]' defaultChecked={filter_item.selected} value={filter_item.url}/> <span>{filter_item.label}</span></label>
                            </TypedLink>
                        </div>;
                    })}                
                </div>
            </div>
            : ''}
        </div>
    </div>

});

export default ProuctsFilters;